module.exports = __webpack_public_path__ + "a92b0235429ad7142ddc1546bd64426d.png";